import { combineReducers } from 'redux';

import { quoteReducer } from './quote/quote.reducer';
import type { RealtimeQuote } from './realtimeQuote.model';
import { realtimeQuoteFormReducer } from './realtimeQuoteForm/realtimeQuoteForm.reducer';
import { tradeReducer } from './trade/trade.reducer';

export const realtimeQuoteReducer = combineReducers<RealtimeQuote>({
  form: realtimeQuoteFormReducer,
  quote: quoteReducer,
  trade: tradeReducer,
});
